import { useEffect } from 'react';
import { toast } from 'react-toastify';

declare global {
  interface Window {
    __FLASH_MESSAGES__?: Record<string, string>;
  }
}

/**
 * Read Rails flash messages injected by PlatformWebProxy into window.__FLASH_MESSAGES__
 * and display them as toast notifications. Clears the messages after reading to
 * prevent re-display on SPA navigation.
 */
export function useFlashMessages() {
  useEffect(() => {
    if (!window.__FLASH_MESSAGES__) return;

    const msgs = { ...window.__FLASH_MESSAGES__ };
    delete window.__FLASH_MESSAGES__;

    // Small delay to let the layout render before showing toasts
    const timer = setTimeout(() => {
      if (msgs.notice) toast.success(msgs.notice);
      if (msgs.alert) toast.error(msgs.alert);
      if (msgs.error) toast.error(msgs.error);
      if (msgs.info) toast.info(msgs.info);
    }, 600);

    return () => clearTimeout(timer);
  }, []);
}
